import CircularProgress from "@material-ui/core/CircularProgress";
export const loading_component = () => {
  return (
    <div>
      <CircularProgress />{" "}
    </div>
  );
};
